import OpenAI from 'openai'
import { GEMINI_PROXY_ADDRESS, GEMINI_VISION_PROXY_ADDRESS, QWEN_API_KEY, QWEN_BASE_URL } from '../config'
import axios from 'axios';
import { extractLargeJSON } from './json.js'
// const { GoogleGenerativeAI } = require("@google/generative-ai");


export async function askLLMForMessages(model, msgs, setMsgList, setAsking) {
	setAsking(true)
	switch (model) {
		case "qwen-72b-chat":
			const openai = new OpenAI(
				{
					apiKey: QWEN_API_KEY,
					baseURL: QWEN_BASE_URL,
					dangerouslyAllowBrowser: true,
				}
			);
			const completion = await openai.chat.completions.create({
				model: "qwen-72b-chat",
				messages: msgs,
			})
			setMsgList([...msgs, { role: "assistant", content: completion.choices[0].message.content }])
			break;
		case "gemini-pro":
			// 直接访问gemini，需要翻墙
			// const genAI = new GoogleGenerativeAI(GOOGLE_API_KEY);
			// const model = genAI.getGenerativeModel({ model: "gemini-pro" });
			// if (msgs.length < 1) {
			// 	break;
			// }
			// const history = msgs.slice(0, msgs.length - 1).map((msg) => {
			// 	if (msg.role === "assistant") {
			// 		return { role: "model", parts: msg.content }
			// 	} else {
			// 		return { role: msg.role, parts: msg.content }
			// 	}
			// })
			// const chat = model.startChat({
			// 	history: history,
			// 	generationConfig: {
			// 		maxOutputTokens: 4096,
			// 		temperature: 0.7,
			// 	},
			// });
			// const result = await chat.sendMessage(msgs[msgs.length - 1].content);
			// setMsgList([...msgs, { "role": "assistant", "content": result.response.text() }])

			// 通过自建代理访问gemini，无需翻墙
			await axios.post(GEMINI_PROXY_ADDRESS, msgs).then(
				response => {
					setMsgList([...msgs, response.data])
				},
				error => {
					console.log("error", error)
				}
			)
			break;
		default:
			break;
	}
	setAsking(false)
}

export async function askLLMForResult(model, msgs, setResult, setAsking) {
	setAsking(true)
	switch (model) {
		case "qwen-72b-chat":
			const openai = new OpenAI(
				{
					apiKey: QWEN_API_KEY,
					baseURL: QWEN_BASE_URL,
					dangerouslyAllowBrowser: true,
				}
			);
			const completion = await openai.chat.completions.create({
				model: "qwen-72b-chat",
				messages: msgs,
			})
			setResult(completion.choices[0].message.content)
			break;
		case "gemini-pro":
			// 直接访问gemini，需要翻墙
			// const genAI = new GoogleGenerativeAI(GOOGLE_API_KEY);
			// const model = genAI.getGenerativeModel({
			// 	model: "gemini-pro",
			// 	generationConfig: {
			// 		temperature: 0.0001,
			// 	}
			// });
			// if (msgs.length < 1) {
			// 	break;
			// }
			// const result = await model.generateContent(msgs.reduce((prev, curr) => { return prev + '\n' + curr.content }, ''));
			// setResult(result.response.text())

			// 通过代理访问gemini，无需翻墙
			await axios.post(GEMINI_PROXY_ADDRESS, [{
				role: "user",
				content: msgs.reduce((prev, curr) => prev + '\n' + curr.content, '')
			}]).then(
				response => {
					setResult(response.data.content)
				},
				error => {
					console.log("error", error)
				}
			)
			break;
		default:
			break;
	}
	setAsking(false)
}

export async function askLLMByImage(model, imageUrl, imageFile, instruct, setResult, setAsking) {
	async function getImageFile(imageUrl) {
		const response = await axios.get(imageUrl, {
			responseType: 'blob'
		});
		const contentType = response.headers['content-type']
		if (contentType && contentType.includes('image/')) {
			const ext = contentType.replace('image/', '')
			const imageFile = new File([response.data], `image.${ext}`, {
				type: ext
			});
			return imageFile;
		} else {
			return null;
		}
	}

	setAsking(true)
	switch (model) {
		case "qwen-72b-chat":
			setResult("当前选择的大模型不支持读图")
			break;
		case "gemini-pro":
			let file = null;
			if (imageFile) {
				file = imageFile
			} else {
				file = await getImageFile(imageUrl);
			}
			if (file) {
				const formData = new FormData();
				formData.append('image', file);
				formData.append('q', instruct);
				await axios.postForm(GEMINI_VISION_PROXY_ADDRESS, formData).then(
					response => {
						setResult(response.data.content)
					},
					error => {
						console.log("error", error)
						setResult("服务器内部错误")
					}
				)
			} else {
				setResult("未获取到图片文件")
			}
			break;
		default:
			break;
	}
	setAsking(false)
}

export async function askLLMForCord(model, item) {
	const { loc } = item;
	var js;
	switch (model) {
		case "qwen-72b-chat":
			const openai = new OpenAI(
				{
					apiKey: QWEN_API_KEY,
					baseURL: QWEN_BASE_URL,
					dangerouslyAllowBrowser: true,
				}
			);
			const completion = await openai.chat.completions.create({
				model: "qwen-72b-chat",
				messages: {
					"role": "user",
					"content": `请以形如{"lat":24.55, "lon":109.78}的json形式，返回${loc}的经纬度坐标，不要添加任何额外字符。`
				},
			})
			js = extractLargeJSON(completion.choices[0].message.content)
			if (js && js.lon && js.lat) {
				return { ...item, lat: js.lat, lon: js.lon }
			} else {
				return item
			}
		case "gemini-pro":
			// 通过代理访问gemini，无需翻墙
			try {
				const response = await axios.post(GEMINI_PROXY_ADDRESS, [{
					role: "user",
					content: `请以形如{"lat":24.55, "lon":109.78}的json形式，返回${loc}的经纬度坐标，不要添加任何额外字符。`
				}]);
				js = extractLargeJSON(response.data.content)
				if (js && js.lon && js.lat) {
					return { ...item, lat: js.lat, lon: js.lon }
				} else {
					return item
				}
			} catch (error) {
				console.log("error", error)
				return item
			}
		default:
			return item
	}
}

